import { render, staticRenderFns } from "./NFTVideoModal.vue?vue&type=template&id=26e3afef"
import script from "./NFTVideoModal.vue?vue&type=script&lang=js"
export * from "./NFTVideoModal.vue?vue&type=script&lang=js"
import style0 from "./NFTVideoModal.vue?vue&type=style&index=0&id=26e3afef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports